import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import {  StyledModal,StyledTitle,StyledBody } from "../../BiometricTab/styles";
import { HealthRiskIcon, SuccessIcon,  NewWarningIcon, RecognitionCloseIcon, } from "../../../utils/icons";
import { InsightModalBody } from "./styles";
import { CommonButton } from "../../common/commonStyles";

class InsightPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  showDetailInitiative = () => {
    const costData = [
      {
        label: 'Average Health mark > 75%',
        icon:SuccessIcon("#91C49D")
      },
      {
        label: 'Average Health mark > 40% - 75%',
        icon: NewWarningIcon('#B1AA56')
      },
      {
        label: 'Average Health mark > 0% - 41%',
        icon:HealthRiskIcon('#DA6C74')
      },
    ];
    return (
      <React.Fragment>
       
        {costData.map(({ label, icon }) => (
          <InsightModalBody key={label}>
            <div className="insight-icon">{icon}</div>
            <div className="text">{label}</div>
          </InsightModalBody>
        ))}

      </React.Fragment>
    );
  };

  render() {
    const { showModal, onClose } = this.props;
    return (
      <StyledModal
        transform={1}
        show={showModal}
        newWidth={"400px"}
        newBg={"newBg"}
        // height="50px"
        display="none"
        // width={"800px"} height={"492px"}
      >
        <Modal.Header
          closeButton
          onHide={() => onClose()}
          style={{ background: "white" }}
        >
          <StyledTitle>Key Health & Wellness Insights </StyledTitle>
          <div
            onClick={() => onClose()}
            style={{ cursor: "pointer" }}
          >
            {RecognitionCloseIcon()}
          </div>
        </Modal.Header>

        <StyledBody style={{padding: "24px 24px 16px 24px"}}>
          {this.showDetailInitiative()}
          <div className='submit-button'>
            <CommonButton margin="12px 0 16px 0" onClick={()=>onClose()}>Got it</CommonButton>
          </div>
        </StyledBody>
      </StyledModal>
    );
  }
}

InsightPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  history: PropTypes.object,
};

export default (InsightPopup);
